import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Leadingdemand(props) {
  return (
    <section className="p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Features App">
              <h2>
                Collaborate with Top Educational Software Developers at TekRevol
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              If you're looking to partner up with expert educational software
              development developers, look no further than TekRevol! We have
              shown our ability to execute world-class solutions for our
              customers on a global scale and claim our rich market share.
              Hence, you can choose our software development company whether you
              belong to a corporate enterprise or an academic institution.
            </p>
            <p>
              Make the smart choice for catering to your diverse educational
              software needs. Our educational software developers possess the
              skills and expertise to bring your idea to life. With our stellar
              project management and transparent workflow, you can trust that
              your project will be handled with care and precision.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Leadingdemand;
